<template>
    <tiptap-options-menu icon="alert" :title="$t('alert')" save-on-blur>
        <field-alert-type v-model="type" :label="$t('type')" required />
    </tiptap-options-menu>
</template>

<script>
export default {
    name: 'TiptapAlertOptions',
    components: {
        TiptapOptionsMenu: () =>
            import(
                /* webpackChunkName: "core" */
                '@/lib/tiptap/components/TiptapOptionsMenu.vue'
            ),
        FieldAlertType: () =>
            import(
                /* webpackChunkName: "fields" */
                '@/components/fields/AlertType'
            )
    },
    props: {
        options: {
            type: Object,
            required: true
        },
        updateAttributes: {
            type: Function,
            required: true
        }
    },
    computed: {
        type: {
            get() {
                return this.options.type;
            },
            set(type) {
                this.updateAttributes({ type });
            }
        }
    }
};
</script>
